import parse from '@tehshrike/duration-iso-8601'

// todo: write test for this
export const getSecondsFromDuration = durationIsoString => {
  let totalSeconds = 0
  const parsedDuration = parse(durationIsoString)
  totalSeconds = parsedDuration.second ? totalSeconds + parsedDuration.second : totalSeconds
  totalSeconds = parsedDuration.minute ? totalSeconds + parsedDuration.minute * 60 : totalSeconds
  totalSeconds = parsedDuration.hour ? totalSeconds + parsedDuration.hour * 3600 : totalSeconds
  return totalSeconds
}

export const getMinutesFromDuration = durationIsoString =>
  getSecondsFromDuration(durationIsoString) / 60
